import { Button } from "@/components/ui/button";

interface SortButtonProps { 
    column: string, 
    currentSort: { sortBy: string, sortDir: string }, 
    onSort: (col: string) => void,
    title?: string,
}

export const SortButton = ({ column, currentSort, onSort, title }: SortButtonProps) => (
    <Button variant="ghost" size="sm" onClick={() => onSort(column)}>
        {title || (column.charAt(0).toUpperCase() + column.slice(1))}
        {currentSort.sortBy === column && (currentSort.sortDir === 'asc' ? ' ↑' : ' ↓')}
    </Button>
);